// DS9.2
import React, { useMemo } from 'react';
import classnames from 'classnames';
import HoverOnly from '../OverlayHelpers/HoverOnly';
import DailyDeviationIndicator from '../../Indicators/DailyDeviationIndicator';
import ThumbStatusIndicator from '../ThumbStatusIndicator';
import MediaIndicator from '../MediaIndicator';
import EngagementIndicator from '../EngagementIndicator';
import s from './ThumbOverlayDefault.scss';
const ThumbOverlayDefault = ({ isDailyDeviation , isFaved , isCommented , statusIndicators , mediaIndicator , duration , width , height , className , children  })=>{
    const isTooNarrow = width && width < 160;
    const isTooShort = height && height < 120;
    const indicators = useMemo(()=>{
        return statusIndicators === null || statusIndicators === void 0 ? void 0 : statusIndicators.slice(0, isDailyDeviation ? 2 : 3);
    }, [
        isDailyDeviation,
        statusIndicators
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        style: {
            width,
            height
        },
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['top']
    }, !isTooShort && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['left'], s['indicators'])
    }, !isTooNarrow && /*#__PURE__*/ React.createElement(React.Fragment, null, isDailyDeviation && /*#__PURE__*/ React.createElement(DailyDeviationIndicator, {
        size: "large",
        className: s['dd']
    }), indicators === null || indicators === void 0 ? void 0 : indicators.map((indicator)=>/*#__PURE__*/ React.createElement(ThumbStatusIndicator, {
            key: indicator,
            type: indicator,
            size: "medium",
            className: s['status-indicator']
        })))), /*#__PURE__*/ React.createElement("div", {
        className: s['right']
    }, mediaIndicator && /*#__PURE__*/ React.createElement(HoverOnly, {
        reverseHidden: true
    }, /*#__PURE__*/ React.createElement(MediaIndicator, {
        type: mediaIndicator,
        duration: duration
    }))))), /*#__PURE__*/ React.createElement("div", {
        className: s['middle']
    }, !isTooNarrow && !isTooShort && children), /*#__PURE__*/ React.createElement("div", {
        className: s['bottom']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left']
    }), /*#__PURE__*/ React.createElement(HoverOnly, {
        reverseHidden: true,
        className: classnames(s['right'], s['engagement'])
    }, isCommented && /*#__PURE__*/ React.createElement(EngagementIndicator, {
        type: "comment"
    }), isFaved && /*#__PURE__*/ React.createElement(EngagementIndicator, {
        type: "fave"
    }))));
};
ThumbOverlayDefault.displayName = 'ThumbOverlayDefault';
export default ThumbOverlayDefault;
